export const DRIVE_CONSTANTS = {
  DOCUMENT: "document",
  MAX_FILE_SIZE: 4 * 1024 * 1024 * 1024,
  LABELS: {
    LOAD_SAMPLE_TITLE: "Load Sample Directory",
    DELETE_ALL_IN_ROOT: "Delete All in Drive",
    GRID_MESSAGE: "Grid view supports drag & drop to move items.",
    GRID_SWITCH: "Switch to grid view to use drag & drop.",
    DELETE_ALL: "Delete All Documents",
  },
  MESSAGES: {
    UNSUPPORTED_FILE_TYPE:
      "File not supported. Please check the file type and try again.",
    PROJECT_DRIVE_UPDATED: "Project drive updated",
    PR_DRIVE_UPDATED: "Project register drive updated",
    TASK_CLAIMS_DRIVE_UPDATED: "Task claims drive updated",
    FILE_SIZE_EXCEEDED: "File size should be less than 4GB",
    UPLOADING_FILE: "Uploading file...",
    DOCUMENT_DELETED: "Document deleted successfully",
    DOCUMENT_CREATED: "Document created successfully",
    DOCUMENT_CREATION_FAILED: "Failed to create document",
    DIRECTORY_DELETED: "Directory deleted successfully",
    DELETE_DOC_WARNING: "If you delete this you cannot restore this document",
    FOLDER_DELETED: "Folder deleted successfully",
    FOLDER_CREATED: "Folder created successfully",
    DOCUMENT_RENAMED: "Document renamed successfully",
    DIRECTORY_RENAMED: "Directory renamed successfully",
    DELETE_FOLDER_WARNING: "If you delete this you cannot restore this folder",
    ADD_NEW: "Add a new file or folder to the drive",
    LOAD_SAMPLE:
      "This will add sample folders and files to your drive. Do you want to proceed?",
    SAMPLE_LOADED: "Sample directory loaded successfully",
    SAMPLE_FAILED: "Failed to load sample documents",
    LOAD_SAMPLE_WARNING:
      "This will add sample folders and files to your drive. Do you want to proceed?",
    BATCH_UPLOAD_FAILED: "Upload failed",
    COMPLEX_UPLOAD:
      "This is a complex upload. Please keep this page open until it completes.",
    BATCH_UPLOAD_SUCCESS: " Upload successfully completed.",
    FILE_UPLOAD_FAILED: "File upload failed",
    DELETE_ALL_WARNING:
      "This will delete all files and folders in this project. This action cannot be undone. Do you want to proceed?",
    DELETE_ALL_SUCCESS: "All files and folders deleted successfully",
    DELETE_ALL_FAILED: "Failed to delete all files and folders",
    FILE_CONNECTION_TIMEOUT:
      "Connection timeout. The server might still be processing your files. Please check the drive in a few minutes.",
    FILE_CONNECTION_TIMEOUT_BUT_SUCCESS:
      "Your upload is processing on the server. The connection timed out, but your files might still be uploading. Please check back in a few minutes.",
    COPY_SUCCESS: "Item copied successfully",
    COPY_ERROR: "Failed to copy item. Please try again.",
    MOVE_SUCCESS: "Item moved successfully",
    MOVE_ERROR: "Failed to move item. Please try again.",
    CANT_MOVE_ON_SAME_FOLDER:
      "You cannot move an item to the same folder. Please select a different folder.",
    TRY_DIFFERENT_KEYWORD: "Try different keywords or browse all files.",
    UPLOAD_NEW_FILE: "Upload files or create a new folder",
    NO_FILE_SELECTED: "No file selected",
  },
};
